export default __webpack_public_path__ + "static/media/EM0440.34I-22012_-14996_0.8d31553c.jpg";